import {useTranslation} from "react-i18next"

export default function SkipLexiconBtn({skipLexiconsStep}) {
    const {t} = useTranslation()
    return (
        <>
        <button className="skip-lexicon-btn" onClick={skipLexiconsStep} title={t("Transcribe")}>{t("Transcribe")}</button>
        </>
    )
}